import * as React from 'react';
import { Button, Spinner, Intent, Callout, FormGroup, InputGroup } from '@blueprintjs/core';
import { executeQueryGetAuth, executeQueryPostAuth } from 'app/utils/api';
import { UserState } from 'app/reducers/state';
import { each, filter } from 'lodash';
import ReactTable from 'react-table';
import { translateKey } from 'app/utils/forms';

interface ClassEntry {
    class: string,
    code: string,
    first: string,
    name: string,
    id: number,
    last: string,
    school: string
}

interface Props {
    user: UserState;
    onSelected: () => void;
};

interface State {
    loadingClasses: boolean;
    classList: ClassEntry[];
    filter: string;
}

export class ClassFinder extends React.Component<Props, State> {

    state: State = {
        loadingClasses: true,
        classList: [],
        filter: ''
    }

    componentDidMount() {
        executeQueryGetAuth("class", {}, this.props.user, (data) => {
            let incomingData = data.body;

            for(let i = 0; i < incomingData.length; i++) {
                incomingData[i].name = incomingData[i].first + " " + incomingData[i].last;

                // Do some/rough bad cleanup :(
                if (incomingData[i].name.includes("null")) {
                    incomingData[i].name = "";
                }
            }

            // Make sure we aren't showing hidden classes
            incomingData = filter(incomingData, data => {
                return parseInt(data['enrollment_hidden']) == 0;
            });

            this.setState({
                loadingClasses: false,
                classList: incomingData
            });
        });
    }

    getFilteredClassList = () => {
        const {
            classList,
            filter
        } = this.state;

        if (filter === "") return []

        let filteredList: any = [];

        each(classList, classEntry => {
            const professsor = classEntry.name.toLowerCase();
            const university = classEntry.school.toLowerCase();
            const code       = classEntry.code.toLowerCase();
            const course     = classEntry.class.toLowerCase();

            const input = filter.toLowerCase();

            if (professsor.includes(input) || university.includes(input) || code.includes(input) || course.includes(input)) {
                filteredList.push(classEntry);
            }
        });

        return filteredList;
    }

    renderSearchInput() {
        return <FormGroup
            helperText={translateKey('login.classFinder')}
            inline={true}
            label={translateKey('vleader.search')}
            labelFor="search-input"
            labelInfo=""
        >
            <InputGroup id="search-input" placeholder="" onChange={(data) => {
                this.setState({
                    filter: data.target.value
                });
            }} />
        </FormGroup>
    }

	render() {
        const {
            loadingClasses
        } = this.state;

        const {
            user
        } = this.props;

        if (loadingClasses) {
            return <Spinner />
        }

        const classList = this.getFilteredClassList();

        const columns = [
            {
                Header: "Professor",
                accessor: "name"
            },
            {
                Header: "Course",
                accessor: "class",
            },
            {
                Header: "School",
                accessor: "school",
            },
            {
                Header: "Code",
                accessor: "code",
            },
            {
                Header: "",
                accessor: "id",
                Cell: (props) => {
                    return <Button intent={Intent.SUCCESS} text="Enroll" onClick={() => {
                        this.setState({
                            loadingClasses: true
                        });

                        // Enroll in this class
                        executeQueryPostAuth("class/enrollment", {
                            user: user.id.toString(),
                            class: props.value.toString()
                        }, this.props.user, () => {
                            this.props.onSelected();
                        });
                    }} />
                }
            }
        ]

        return <span>
            <Callout style={{marginBottom: '20px', marginTop: '20px'}} icon="info-sign" intent={Intent.PRIMARY} title={translateKey('vleader.findClass')}>
				{translateKey('vleader.noClassWarning')}
			</Callout>

            {this.renderSearchInput()}

            <ReactTable noDataText={translateKey('vleader.noClassData')} columns={columns} data={classList} pageSize={classList.length} showPagination={false} showPageSizeOptions={false} />
        </span>
	}
}
